import LayoutIndex from 'layouts/Index'
import LayoutLogin from 'layouts/Login'
import LayoutCategory from 'layouts/Categories'
import LayoutZones from 'layouts/Zones'

import PageCagetoriesIndex from 'pages/categories/Index'
import PageCategoriesChilds from 'pages/categories/Childs'
import PageCategoriesIssue from 'pages/categories/Issue'

import PageZonesIndex from 'pages/zones/Index'
import PageZonesPlaces from 'pages/zones/Places'
import PageZonesAudits from 'pages/zones/Audits'
import PageZonesReport from 'pages/zones/Report'
import PageZonesIssue from 'pages/zones/Issue'

import PageHistoryIndex from 'pages/history/Index'
import PageTaskList from 'pages/TaskList'

import PageLogin from 'pages/Login'
import PageResetPassword from 'pages/ResetPassword'
import PageFirstLogin from 'pages/FirstLogin'
import PageSetPassword from 'pages/SetPassword'
import PageCallback from 'pages/callback/Index'

const routes = [
  {
    name: 'home',
    path: '/',
    redirect: { path: '/login' },
    component: LayoutIndex,
    children: [
      { path: 'categories', component: PageCagetoriesIndex },
      { path: 'zones', component: PageZonesIndex },
      { path: 'history', component: PageHistoryIndex },
      { path: 'taskList', name: 'taskList', component: PageTaskList }
    ]
  },
  {
    name: 'login',
    path: '/login',
    component: LayoutLogin,
    children: [{ path: '', component: PageLogin, name: 'Login' }]
  },
  // Magiclink flow (first login / forgotten password). Public routes: the user has
  // no token yet - see boot/routerGuards.js.
  {
    path: '/first-login',
    component: LayoutLogin,
    children: [{ path: '', component: PageFirstLogin, name: 'FirstLogin' }]
  },
  {
    path: '/set-password',
    component: LayoutLogin,
    children: [{ path: '', component: PageSetPassword, name: 'SetPassword' }]
  },
  {
    name: 'ResetPassword',
    path: '/ResetPassword',
    component: LayoutLogin,
    props: (route) => ({ query: route.query.key }),
    children: [
      { path: '', component: PageResetPassword, name: 'ResetPassword' }
    ]
  },
  {
    name: 'categories',
    path: '/categories',
    component: LayoutCategory,
    children: [
      {
        path: ':id/childs',
        component: PageCategoriesChilds,
        name: 'subcategories'
      },
      { path: ':id/issue', component: PageCategoriesIssue }
    ]
  },
  {
    path: '/zones',
    component: LayoutZones,
    children: [
      { path: ':id', component: PageZonesPlaces },
      {
        path: ':zoneId/places/:placeId',
        component: PageZonesAudits,
        name: 'audits'
      },
      {
        path: ':zoneId/places/:placeId/audits/:auditId',
        component: PageZonesReport,
        name: 'newReport'
      },
      {
        path: ':zoneId/places/:placeId/audits/:auditId/issue',
        component: PageZonesIssue,
        name: 'newIssue'
      }
    ]
  },
  {
    name: 'issuesList',
    path: '/history',
    component: LayoutIndex,
    children: [
      {
        name: 'issueDetail',
        path: ':id',
        component: PageHistoryIndex
      } // Allows issue detail popup to be opened automatically when user is comming from a notification
    ]
  },
  {
    path: '/:catchAll(.*)*',
    redirect: '/categories'
  },
  {
    path: '/callback',
    component: LayoutLogin,
    children: [
      {
        path: '',
        component: PageCallback,
        name: 'callback'
      }
    ]
  }
]

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
}

export default routes
